import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import HighlightedSearch from '../../HighlightedSearch';
import * as styles from './CategorizedListSection.scss';

/**
 * Reusable CategorizedList Section Component
 * @function CategorizedListSection
 * @param {Object} props
 * @return {ReactElement}
 */
const CategorizedListSection = props => {
  const {
    className,
    onClick,
    options = [],
    title,
    searchValue,
    style,
  } = props;

  return (
    <div className={classNames(styles.categorizedListSection, className)} style={style}>
      <div className={styles.sectionHeader}>
        <p className={styles.sectionTitle} title={title}>{title}</p>
      </div>
      <ul className={styles.optionsList}>
        {options.map(option => {
          return (
            <li
              className={classNames(styles.optionListItem, option.className)}
              key={option.displayValue}
              onClick={() => onClick(option)}
              style={option.style}
              title={option.displayValue}
            >
              <div className={styles.listItemContent}>
                <HighlightedSearch searchValue={searchValue} textValue={option.displayValue} />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

CategorizedListSection.propTypes = {
  onClick: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      displayValue: PropTypes.string,
      style: PropTypes.objectOf(
        PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
      ),
      value: PropTypes.any,
    }),
  ),
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
  title: PropTypes.string,
};

export default CategorizedListSection;
